// A segmented control has to sit against its surroundings, not on them: the
// gray track reads on a white card, the white track on the gray page body.

export type SegmentedTrack = 'gray' | 'white';

export const SEGMENTED_TRACK_CLASSES: Record<SegmentedTrack, string> = {
    gray: 'bg-gray-100 border-gray-200',
    white: 'bg-white border-gray-200'
};
